<div class="custom-tooltip">
  <span class="fa" [ngClass]="{ 'fa-info': !isShown, 'fa-times': isShown }" (click)="click($event)"></span>
  <div *ngIf="isShown" class="custom-tooltip-content" [innerHtml]="html"></div>
</div>
